export default __webpack_public_path__ + "static/media/Facebook 3d logo.fbf30022.svg";